import React, { useEffect, useState } from 'react';
import useTipsData from 'features/Big9Tips/state/useTipsData';
import { TipsPageWrapper } from 'features/Big9Tips/styled';
import TipsHighlight from 'features/Big9Tips/TipsHighlight';
import TipsList from 'features/Big9Tips/TipsList';
import { timeToUTC } from 'features/SpilKlub/state/helpers';

const Big9Tips = () => {
    const { tipsData, status, setTag } = useTipsData();
    const [highlightItem, setHighlightItem] = useState({});
    const [sortedData, setSortedData] = useState(tipsData);

    const sortTipsByDate = (a, b) =>
        timeToUTC(a.beginning) < timeToUTC(b.beginning) ? 1 : -1;

    useEffect(
        () => {
            if (tipsData) {
                const sortData = tipsData.sort(sortTipsByDate);
                setSortedData(sortData);
                sortData.length &&
                    !Object.keys(highlightItem).length &&
                    setHighlightItem(
                        sortData.find((item) => item.is_highlight === '1') ||
                            sortData[0]
                    );
            }
        },
        [tipsData]
    );

    return (
        <TipsPageWrapper>
            <TipsHighlight item={highlightItem} status={status} />
            <TipsList
                data={sortedData}
                onChange={setTag}
                status={status}
                selectArticle={setHighlightItem}
            />
        </TipsPageWrapper>
    );
};

export default Big9Tips;
